import React, { Component } from "react";
import { withStyles } from "material-ui/styles";
import Grid from "material-ui/Grid";
import { get } from "../../services/apiServices";
import { post } from "../../services/apiServices";
import { token } from "../../services/authServices";
import TextField from "material-ui/TextField";
import { InputLabel } from "material-ui/Input";
import { FormControl } from "material-ui/Form";
import { FormControlLabel } from "material-ui/Form";
import Dialog, { DialogTitle, DialogActions } from "material-ui/Dialog";
import Table, {
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from 'material-ui/Table'
import Icon from 'material-ui/Icon'
import Button from "material-ui/Button";
import { CircularProgress } from "material-ui/Progress";

const styles = {
    closeIcon: {
        position: 'absolute',
        top: '10px',
        right: '10px',
        color: '#a9a9a9',
        cursor: 'pointer'
    },
    editIcon: {
        padding: '10px',
        cursor: 'pointer'
    },
    button: {
        width: '120px',
        margin: '0 auto 40px'
    },
    titleWrap: {
        marginTop: '15px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    title: {
        color: '#3f51b5'
    },
    table: {
        minWidth: 700,
    },
    tableRow: {
        cursor: 'pointer'
    },
    listItem: {
        width: "480px",
        alignItems: "flex-start",
        borderBottom: "1px solid rgba(224, 224, 224, 1)"
    },
    listItemText: {
        flex: "1 1 50%"
    },
    listItemTtitle: {
        fontWeight: 600
    },
    progressWrapper: {
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    progress: {
    }
};
class Settings extends Component {
    classes = this.props.classes;
    state = {
        openSettingModal: false,
        currentSetting: {}
    }
    componentWillMount() {
        this.props.getSettings()
    }

    renderSettingsList = () => {
        let { settings } = this.props
        let result = settings.data.map(item => {
            return (
                <TableRow
                    className={this.classes.tableRow}
                    key={item.id}>
                    <TableCell padding='none'>
                        {item.key}
                    </TableCell>
                    <TableCell padding='none'>
                        {item.value}
                    </TableCell>
                    <TableCell padding='none'>
                        {item.description}
                    </TableCell>
                    <TableCell width="100px" padding='none'>
                        <Icon
                            className={this.classes.editIcon}
                            onClick={(e) =>
                                this.editSetting(item)}>
                            mode_edit
						</Icon>
                    </TableCell>
                </TableRow>
            )
        })

        return result.map(item => item)
    }

    editSetting = (item = {}) => {
        this.setState({ currentSetting: item })
        this.handleOpenSettingModal()
    }

    handleOpenSettingModal = () => {
        this.setState({ openSettingModal: true })
    }

    handleCloseSettingModal = () => {
        this.setState({ openSettingModal: false })
    }

    handleInputChange = e => {
        let { currentSetting } = this.state
        currentSetting[e.target.name] = e.target.value;
        this.setState({currentSetting})
    }

    onSubmit = () => {
        const { currentSetting } = this.state
        let id = currentSetting.id ? `/${currentSetting.id}` : ''

        post(`/admin/settings${id}`, currentSetting, token).then(res => {
            this.handleCloseSettingModal();
            this.props.getSettings()
        })
    }

    render() {
        const { settings } = this.props
        const { openSettingModal, currentSetting } = this.state
        let isFetching = settings ? settings.isFetching : true;

        return isFetching ? (
            <div className={this.classes.progressWrapper}>
                <CircularProgress className={this.classes.progress} size={50} />
            </div>
        ) : (
                <div>
                    <Dialog
                        className="modal-wrap align-center"
                        open={openSettingModal}
                        onClose={this.handleCloseSettingModal}
                        aria-labelledby="simple-dialog-title">
                        <Icon
                            className={this.classes.closeIcon}
                            onClick={this.handleCloseSettingModal}>
                            close
					</Icon>
                        {
                            currentSetting.id ?
                                (
                                    <DialogTitle id="simple-dialog-title">
                                        Edit setting
							</DialogTitle>
                                ) :
                                (
                                    <DialogTitle id="simple-dialog-title">
                                        Add setting
							</DialogTitle>
                                )
                        }
                        <div className="input-wrap">
                            <TextField
                                id="key"
                                label="Name"
                                name="key"
                                value={currentSetting.key}
                                onInput={this.handleInputChange}
                                margin="normal"
                                fullWidth
                            />
                        </div>
                        <div className="input-wrap">
                            <TextField
                                id="value"
                                label="Value"
                                name="value"
                                value={currentSetting.value}
                                onInput={this.handleInputChange}
                                margin="normal"
                                fullWidth
                            />
                        </div>
                        <div className="input-wrap">
                            <TextField
                                id="description"
                                label="Description"
                                name="description"
                                value={currentSetting.description}
                                onInput={this.handleInputChange}
                                margin="normal"
                                fullWidth
                            />
                        </div>
                        <Button
                            variant="raised"
                            color="primary"
                            className={this.classes.button}
                            onClick={this.onSubmit}
                        //disabled={disable}
                        >
                            {currentSetting.id ? "Edit" : "Add"}
                        </Button>
                    </Dialog>
                    <div className={this.classes.titleWrap}>
                        <h2 className={this.props.classes.title}>Settings</h2>
                        <Button
                            variant="raised"
                            color="primary"
                            onClick={() => this.editSetting()}>
                            Add new setting
						</Button>
                    </div>
                    {settings && settings.data.length ?
                        <Table className={this.classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell padding='none'>
                                        NAME
									</TableCell>
                                    <TableCell padding='none'>
                                        VALUE
									</TableCell>
                                    <TableCell padding='none'>
                                        DESCRIPTION
									</TableCell>
                                    <TableCell padding='none'>
                                        ACTIONS
									</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.renderSettingsList()}
                            </TableBody>
                        </Table> : null}
                </div>
            )
    }
}

export default withStyles(styles)(Settings);


// WEBPACK FOOTER //
// ./src/components/content/Settings.js